module.exports = __webpack_public_path__ + "img/owasp.bf71df18.svg";